// src/fleet-stats/analytics/buildDailySeries.js

/**
 * Build a daily time series from flat rows.
 * Adds 7-day rolling averages for km and hours.
 * Adds isWeekend flag for weekday/weekend pattern analysis.
 */
export function buildDailySeries(rows) {
    const byDate = new Map();

    for (const r of rows) {
        const cur = byDate.get(r.date) || {
            date: r.date,
            distance_m: 0,
            moving_time_s: 0,
            uptime_s: 0,
        };
        cur.distance_m += r.distance_m;
        cur.moving_time_s += r.moving_time_s;
        cur.uptime_s += (r.uptime_s || 0);
        byDate.set(r.date, cur);
    }

    const sorted = Array.from(byDate.values()).sort((a, b) =>
        a.date < b.date ? -1 : 1
    );

    return sorted.map((row, i) => {
        const start = Math.max(0, i - 6);
        const window = sorted.slice(start, i + 1);
        const kmAvg = window.reduce((a, d) => a + d.distance_m / 1000, 0) / window.length;
        const hoursAvg = window.reduce((a, d) => a + d.moving_time_s / 3600, 0) / window.length;

        const dow = new Date(row.date + "T00:00:00Z").getUTCDay();
        const isWeekend = dow === 0 || dow === 6;

        return {
            date: row.date,
            km: row.distance_m / 1000,
            hours: row.moving_time_s / 3600,
            uptime_h: row.uptime_s / 3600,
            km_7d: kmAvg,
            hours_7d: hoursAvg,
            isWeekend,
        };
    });
}